import { FontWeight, Heading, LiliButton, LiliButtonType, Text } from '@lili/lili-frontend-common';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { navigateToRelevantAddMoney } from '../../../router/constants';
import { ReactComponent as ErrorIcon } from '../../../assets/icons/svg/shared/ic-shared-error.svg';
import { OverdraftState } from '../../../types';
import { featureAccess, LimitedFeatureType } from '../../../services/appAccess.service';
import { FeatureAccess } from '../../../pages/AccountSettings/components/rolesAndPermissions/PermissionsList';

type BalanceUpDashboardAlertProps = {
  eligibilityUsed: number;
  eligibilityLimit: number;
  overdraftState: OverdraftState;
};

export const BalanceUpDashboardAlert = ({
  eligibilityUsed,
  eligibilityLimit,
  overdraftState,
}: BalanceUpDashboardAlertProps) => {
  const { t } = useTranslation('balanceUpTranslation');
  const navigate = useNavigate();
  const addMoneyLickedAccountPermission = featureAccess(null, LimitedFeatureType.AddMoneyACHLinkedAccount);
  const addMoneyDirectDepositPermission = featureAccess(null, LimitedFeatureType.AddMoneyACHDirectDeposit);

  const onAddMoneyClick = () => {
    navigateToRelevantAddMoney(navigate);
  };
  return (
    <div className='flex py-[16px] px-[24px] rounded-[8px] bg-surface-primary-bw-01 outline outline-outline-primary-bw-03 outline-1'>
      <div className='flex w-full flex-row items-center justify-between gap-[16px]'>
        {overdraftState === OverdraftState.OPTED_IN && eligibilityLimit - eligibilityUsed <= 0 && (
          <div className='flex flex-col'>
            <Heading.H9 fontWeight={FontWeight.SEMIBOLD}>{t('DASHBOARD.NO_BALANCE')}</Heading.H9>
            <Text.H10 className='whitespace-pre-line'>{t('DASHBOARD.NO_BALANCE_DESCRIPTION')}</Text.H10>
          </div>
        )}
        {overdraftState === OverdraftState.REVOKED && eligibilityUsed === 0 && (
          <div className='flex flex-col'>
            <Heading.H9 fontWeight={FontWeight.SEMIBOLD}>{t('DASHBOARD.REVOKED_PENDING_RENEWAL')}</Heading.H9>
            <Text.H10 className='whitespace-pre-line'>{t('DASHBOARD.REVOKED_PENDING_RENEWAL_DESCRIPTION')}</Text.H10>
          </div>
        )}
        {overdraftState === OverdraftState.REVOKED && eligibilityUsed > 0 && (
          <div className='flex flex-row items-start gap-[8px]'>
            <ErrorIcon className='rounded-full p-[3px] w-[24px] h-[24px] bg-surface-negative-secondary' />
            <div className='flex flex-col'>
              <Heading.H9 fontWeight={FontWeight.SEMIBOLD}>{t('DASHBOARD.REVOKED_COVER_CREDIT')}</Heading.H9>
              <Text.H10 className='whitespace-pre-line'>{t('DASHBOARD.REVOKED_COVER_CREDIT_DESCRIPTION')}</Text.H10>
            </div>
          </div>
        )}
        <div className='pc-md:w-[119px] w-[150px]'>
          <LiliButton
            id='add-money-cta'
            type={LiliButtonType.PRIMARY}
            title={t('DASHBOARD.NO_BALANCE_CTA')}
            onClick={onAddMoneyClick}
            disabled={
              addMoneyLickedAccountPermission !== FeatureAccess.READ_WRITE &&
              addMoneyDirectDepositPermission !== FeatureAccess.READ_WRITE
            }
          />
        </div>
      </div>
    </div>
  );
};
